import { render, staticRenderFns } from "./CoDashBoard.vue?vue&type=template&id=34942397&"
import script from "./CoDashBoard.vue?vue&type=script&lang=ts&"
export * from "./CoDashBoard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports